export default {
  edit: "stringTemplate:edit",
  create: "stringTemplate:create",
  delete: "stringTemplate:delete",
  view: "stringTemplate:view",
};
